import { render, staticRenderFns } from "./index.vue?vue&type=template&id=491db54d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491db54d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491db54d')) {
      api.createRecord('491db54d', component.options)
    } else {
      api.reload('491db54d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=491db54d&scoped=true&", function () {
      api.rerender('491db54d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormItem/TDateTime/index.vue"
export default component.exports